// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1rqPq","radioRow":"SimpleQuestionBuilderModal_radioRow__3BIf3"};